var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"faq-search-filter"}},[_c('b-card',{staticClass:"faq-search",style:({
      backgroundImage: ("url(" + (require('@/assets/images/banner/banner.png')) + ")"),
      height: '300px',
    }),attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"text-center"},[_c('h2',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.massage))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }